import DashboardIcon from "@mui/icons-material/Dashboard";
import TurnedInIcon from "@mui/icons-material/TurnedIn";
import PostAddIcon from "@mui/icons-material/PostAdd";
import FolderIcon from "@mui/icons-material/Folder";
import WarningIcon from "@mui/icons-material/Warning";
// import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

const links = [
  {
    title: "Home",
    role: "admin",
    links: [
      {
        name: "Dashboard",
        path: "i-abide-dashboard",
        icon: <DashboardIcon />,
      },
    ],
  },
  {
    title: "Contents",
    role: "admin",
    links: [
      {
        name: "Directories",
        path: "directories",
        icon: <FolderIcon />,
      },
      {
        name: "Posts",
        path: "posts",
        icon: <PostAddIcon />,
      },
      {
        name: "Submissions Logs",
        path: "submissions",
        icon: <TurnedInIcon />,
      },
      {
        name: "Rejected Submissions",
        path: "rejects",
        icon: <WarningIcon />,
      },
    ],
  },

  // education program supervisor
  {
    title: "Home",
    role: "education program supervisor",
    links: [
      {
        name: "Dashboard",
        path: "i-abide-dashboard",
        icon: <DashboardIcon />,
      },
    ],
  },
  {
    title: "Contents",
    role: "education program supervisor",
    links: [
      {
        name: "Posts",
        path: "posts",
        icon: <PostAddIcon />,
      },
      {
        name: "Submissions Logs",
        path: "submissions",
        icon: <TurnedInIcon />,
      },
      {
        name: "Rejected Submissions",
        path: "rejects",
        icon: <WarningIcon />,
      },
    ],
  },

  // education program specialist 2
  {
    title: "Home",
    role: "education program specialist 2",
    links: [
      {
        name: "Dashboard",
        path: "i-abide-dashboard",
        icon: <DashboardIcon />,
      },
    ],
  },
  {
    title: "Contents",
    role: "education program specialist 2",
    links: [
      {
        name: "Posts",
        path: "posts",
        icon: <PostAddIcon />,
      },
      {
        name: "Submissions Logs",
        path: "submissions",
        icon: <TurnedInIcon />,
      },
      {
        name: "Rejected Submissions",
        path: "rejects",
        icon: <WarningIcon />,
      },
    ],
  },

  // administrative officer 2
  {
    title: "Home",
    role: "administrative officer 2",
    links: [
      {
        name: "Dashboard",
        path: "i-abide-dashboard",
        icon: <DashboardIcon />,
      },
    ],
  },
  {
    title: "Contents",
    role: "administrative officer 2",
    links: [
      {
        name: "Posts",
        path: "posts",
        icon: <PostAddIcon />,
      },
      {
        name: "Submissions Logs",
        path: "submissions",
        icon: <TurnedInIcon />,
      },
      {
        name: "Rejected Submissions",
        path: "rejects",
        icon: <WarningIcon />,
      },
    ],
  },

  // administrative officer 5
  {
    title: "Home",
    role: "administrative officer 5",
    links: [
      {
        name: "Dashboard",
        path: "i-abide-dashboard",
        icon: <DashboardIcon />,
      },
    ],
  },
  {
    title: "Contents",
    role: "administrative officer 5",
    links: [
      {
        name: "Posts",
        path: "posts",
        icon: <PostAddIcon />,
      },
      {
        name: "Submissions Logs",
        path: "submissions",
        icon: <TurnedInIcon />,
      },
      {
        name: "Rejected Submissions",
        path: "rejects",
        icon: <WarningIcon />,
      },
    ],
  },

  // administrative officer 4
  {
    title: "Home",
    role: "administrative officer 4",
    links: [
      {
        name: "Dashboard",
        path: "i-abide-dashboard",
        icon: <DashboardIcon />,
      },
    ],
  },
  {
    title: "Contents",
    role: "administrative officer 4",
    links: [
      {
        name: "Posts",
        path: "posts",
        icon: <PostAddIcon />,
      },
      {
        name: "Submissions Logs",
        path: "submissions",
        icon: <TurnedInIcon />,
      },
      {
        name: "Rejected Submissions",
        path: "rejects",
        icon: <WarningIcon />,
      },
    ],
  },

  // senior education program specialist
  {
    title: "Home",
    role: "senior education program specialist",
    links: [
      {
        name: "Dashboard",
        path: "i-abide-dashboard",
        icon: <DashboardIcon />,
      },
    ],
  },
  {
    title: "Contents",
    role: "senior education program specialist",
    links: [
      {
        name: "Posts",
        path: "posts",
        icon: <PostAddIcon />,
      },
      {
        name: "Submissions Logs",
        path: "submissions",
        icon: <TurnedInIcon />,
      },
      {
        name: "Rejected Submissions",
        path: "rejects",
        icon: <WarningIcon />,
      },
    ],
  },

  // project development officer 1
  {
    title: "Home",
    role: "project development officer 1",
    links: [
      {
        name: "Dashboard",
        path: "i-abide-dashboard",
        icon: <DashboardIcon />,
      },
    ],
  },
  {
    title: "Contents",
    role: "project development officer 1",
    links: [
      {
        name: "Posts",
        path: "posts",
        icon: <PostAddIcon />,
      },
      {
        name: "Submissions Logs",
        path: "submissions",
        icon: <TurnedInIcon />,
      },
      {
        name: "Rejected Submissions",
        path: "rejects",
        icon: <WarningIcon />,
      },
    ],
  },

  // project development officer 2
  {
    title: "Home",
    role: "project development officer 2",
    links: [
      {
        name: "Dashboard",
        path: "i-abide-dashboard",
        icon: <DashboardIcon />,
      },
    ],
  },
  {
    title: "Contents",
    role: "project development officer 2",
    links: [
      {
        name: "Posts",
        path: "posts",
        icon: <PostAddIcon />,
      },
      {
        name: "Submissions Logs",
        path: "submissions",
        icon: <TurnedInIcon />,
      },
      {
        name: "Rejected Submissions",
        path: "rejects",
        icon: <WarningIcon />,
      },
    ],
  },

  // accountant 3
  {
    title: "Home",
    role: "accountant 3",
    links: [
      {
        name: "Dashboard",
        path: "i-abide-dashboard",
        icon: <DashboardIcon />,
      },
    ],
  },
  {
    title: "Contents",
    role: "accountant 3",
    links: [
      {
        name: "Posts",
        path: "posts",
        icon: <PostAddIcon />,
      },
      {
        name: "Submissions Logs",
        path: "submissions",
        icon: <TurnedInIcon />,
      },
      {
        name: "Rejected Submissions",
        path: "rejects",
        icon: <WarningIcon />,
      },
    ],
  },

  // chief education supervisor
  {
    title: "Home",
    role: "chief education supervisor",
    links: [
      {
        name: "Dashboard",
        path: "i-abide-dashboard",
        icon: <DashboardIcon />,
      },
    ],
  },
  {
    title: "Contents",
    role: "chief education supervisor",
    links: [
      {
        name: "Posts",
        path: "posts",
        icon: <PostAddIcon />,
      },
      {
        name: "Submissions Logs",
        path: "submissions",
        icon: <TurnedInIcon />,
      },
      {
        name: "Rejected Submissions",
        path: "rejects",
        icon: <WarningIcon />,
      },
    ],
  },

  // cid - chief
  {
    title: "Home",
    role: "cid - chief",
    links: [
      {
        name: "Dashboard",
        path: "i-abide-dashboard",
        icon: <DashboardIcon />,
      },
    ],
  },
  {
    title: "Contents",
    role: "cid - chief",
    links: [
      {
        name: "Posts",
        path: "posts",
        icon: <PostAddIcon />,
      },
      {
        name: "Submissions Logs",
        path: "submissions",
        icon: <TurnedInIcon />,
      },
      {
        name: "Rejected Submissions",
        path: "rejects",
        icon: <WarningIcon />,
      },
    ],
  },

  // osds
  {
    title: "Home",
    role: "osds",
    links: [
      {
        name: "Dashboard",
        path: "i-abide-dashboard",
        icon: <DashboardIcon />,
      },
    ],
  },
  {
    title: "Contents",
    role: "osds",
    links: [
      {
        name: "Posts",
        path: "posts",
        icon: <PostAddIcon />,
      },
      {
        name: "Submissions Logs",
        path: "submissions",
        icon: <TurnedInIcon />,
      },
      {
        name: "Rejected Submissions",
        path: "rejects",
        icon: <WarningIcon />,
      },
    ],
  },

  // schools
  {
    title: "Documents",
    role: "teacher",
    links: [
      {
        name: "Dashboard",
        path: "iabide-school-dashboard",
        icon: <DashboardIcon />,
      },
      {
        name: "Documents",
        path: "submissions",
        icon: <PostAddIcon />,
      },
      {
        name: "Rejected Submissions",
        path: "rejects",
        icon: <WarningIcon />,
      },
    ],
  },

  {
    title: "Documents",
    role: "school head",
    links: [
      {
        name: "Dashboard",
        path: "iabide-school-dashboard",
        icon: <DashboardIcon />,
      },
      {
        name: "Documents",
        path: "submissions",
        icon: <PostAddIcon />,
      },
      {
        name: "Rejected Submissions",
        path: "rejects",
        icon: <WarningIcon />,
      },
    ],
  },

  {
    title: "Documents",
    role: "school non-teaching personnel",
    links: [
      {
        name: "Dashboard",
        path: "iabide-school-dashboard",
        icon: <DashboardIcon />,
      },
      {
        name: "Documents",
        path: "submissions",
        icon: <PostAddIcon />,
      },
      {
        name: "Rejected Submissions",
        path: "rejects",
        icon: <WarningIcon />,
      },
    ],
  },
];

export default links;
